// extracted by mini-css-extract-plugin
export default {"markAsPaidPopup":"MarkBillAsPaidPopup_markAsPaidPopup__LOWTN"};